import { Box, TextField } from "@mui/material";
import { CreateWorkflowFormItemWrapper } from "./styles";
import { ReactNode } from "react";

interface CreateWorkflowFormItemProps {
  name: string | null;
  desciption: string | null;
  icon?: ReactNode;
  input: ReactNode;
}

const CreateWorkflowFormItem = (props: CreateWorkflowFormItemProps) => {
  return (
    <CreateWorkflowFormItemWrapper
      className="FormItem"
      display={"flex"}
      flexDirection={"row"}
    >
      <Box width={"30%"}>
        <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
          {props.icon}
          <p className="FormItemName">{props.name}</p>
        </Box>
        <span className="FormItemDesc">{props.desciption}</span>
      </Box>
      <Box width={"70%"} flexGrow={1} paddingLeft={1}>
        {props.input}
      </Box>
    </CreateWorkflowFormItemWrapper>
  );
};

export default CreateWorkflowFormItem;
